import { clearInputField } from '../../helpers';

export const setUpSmallInvestorFields = ($form) => {
  const $investorCategoryRadio = $('#investor_risk_categorization_buttons input[type=radio]', $form);

  $investorCategoryRadio.on('change', (e) => {
    if (!e.target.checked) return;

    if (e.target.name.includes('[investor_risk_categorization]')) {
      let $investoryCategoryNestedFields = $('.investor_risk_categorization_nested_fields', $form);
      let selectedInvestorCategoryNestedFieldsID = `${e.target.value}_nested_fields`;

      $investoryCategoryNestedFields.each((_, fields) => {
        if (fields.id === selectedInvestorCategoryNestedFieldsID) {
          $(fields).removeClass('d-none');
        } else {
          $(fields).addClass('d-none');
          $('input', fields).each((_, inputElement) => {
            clearInputField(inputElement);
          });
        }
      });
    }
  });
};
